import { Link } from "react-router-dom";
import { useBrandStore } from "@/store/brandStore";
import { useTranslation } from "react-i18next";

export function Footer() {
  const { t } = useTranslation();
  const { name, logo } = useBrandStore();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-muted py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <Link
              to="/"
              className="flex items-center gap-2 font-bold text-2xl tracking-tight mb-4"
            >
              {logo ? (
                <img src={logo} alt={name} className="h-8" />
              ) : (
                <span className="text-cultry-primary">
                  {t("footer.brandName")}
                </span>
              )}
              <span>{t("footer.brandSuffix")}</span>
            </Link>
            <p className="text-muted-foreground mb-4">
              {t("footer.description")}
            </p>
          </div>

          <div>
            <h3 className="font-medium mb-3">{t("footer.productTitle")}</h3>
            <ul className="space-y-2">
              {["features", "solutions", "pricing", "demo", "security"].map(
                (item) => (
                  <li key={item}>
                    <a
                      href="#"
                      className="text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {t(`footer.product.${item}`)}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>

          <div>
            <h3 className="font-medium mb-3">{t("footer.companyTitle")}</h3>
            <ul className="space-y-2">
              {["about", "blog", "contact"].map((item) => (
                <li key={item}>
                  <a
                    href="#"
                    className="text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {t(`footer.company.${item}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-medium mb-3">{t("footer.resourcesTitle")}</h3>
            <ul className="space-y-2">
              {["faq", "helpCenter", "partners", "status"].map((item) => (
                <li key={item}>
                  <a
                    href="#"
                    className="text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {t(`footer.resources.${item}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            &copy; {currentYear} {t("footer.copyright")}
          </p>

          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            {["privacyPolicy", "termsOfService", "cookies"].map((item) => (
              <a
                key={item}
                href="#"
                className="hover:text-foreground transition-colors"
              >
                {t(`footer.legal.${item}`)}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
